import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from "@jti/store";
import { Button } from "@jti/ui";
import trackCtaClick from "../../helpers/functions/trackCtaClick";
import useLoggedUser from "../../helpers/hooks/useLoggedUser";
import { ConditionalView } from "../conditional-view/ConditionalView";
import ReferralStatsItem from "./ReferralStatsItem";
import styles from "./ReferralStats.module.scss";
export const ReferralStats = ({ title, referralstatslist, referralhistory, referralhistorylink, isInEditor, }) => {
    const [isLogged] = useLoggedUser();
    const { isReferralOn } = useSelector((state) => state.loyaltyCore);
    const { referralStats } = useSelector((state) => state.loyaltyCore);
    const dispatchGTMEvent = () => {
        trackCtaClick(referralhistory, "ReferralStatsCTA");
    };
    const valueByType = (type) => {
        switch (type) {
            case "totalReward":
                return referralStats?.earned_points;
            case "createdAccount":
                return referralStats?.referees_count;
            case "completedFirstOrder":
                return referralStats?.completed_first_order_count;
            default:
                return "";
        }
    };
    return (_jsx(ConditionalView, { condition: (isLogged && isReferralOn) || isInEditor, children: _jsx("div", { className: styles.block, children: _jsx("div", { className: styles.holder, children: _jsxs("div", { className: styles.outline, children: [_jsx("div", { className: styles.infoBlock, children: _jsx("div", { className: styles.title, "data-testid": "referralStatsTitle", children: title }) }), _jsxs("div", { className: styles.referreesBlock, "data-testid": "referralStatsBlock", children: [referralstatslist.map((item, id) => (_jsx(ReferralStatsItem, { imageUrl: item.imageUrl, description: item.description, value: valueByType(item.value), dataTestId: item.value }, id))), _jsx("div", { className: styles.linkWrapper, children: _jsx(Button, { variant: "redirect", color: "secondary", "data-testid": "arrow-link", size: "large", href: referralhistorylink, onClick: dispatchGTMEvent, theme: "light", children: referralhistory }) })] })] }) }) }) }));
};
//# sourceMappingURL=ReferralStats.js.map